import { makeStyles } from '@material-ui/core';

export const mailStyles = makeStyles({
  buttonAdicionarEmail: {
    color: '#53c4e6',
    fontSize: 15,
  },

  buttonRemoverEmail: {
    display: 'flex',
    justifyContent: 'center',
  },
});
